import React, { useState } from "react";
import { Link } from "gatsby";
import {
  Button,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContainer,
  TabContent,
  TabPane,
} from "react-bootstrap";
import * as styles from "./style.module.scss";
import { FaChevronRight } from "react-icons/fa";

const Services = ({ data }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabHover = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const [showIcon, setShowIcon] = useState(false);
  const [hoveredTab, setHoveredTab] = useState(-1);
  const NavBarData = [
    {
      mobileLabel: "View All",
      link: "/services/",
      label: "Services",
      disabled: false,
      dropdown: true,
      subMenuType: "list",
      subMenu: [
        {
          link: "/smart-contract-development/",
          label: "Smart Contract",
          disabled: false,
        },
        {
          link: "/blockchain-consulting-services/",
          label: "Blockchain Consultancy",
          disabled: false,
        },
        {
          link: "/enterprise-blockchain-development/",
          label: "Enterprise Blockchain Development",
          disabled: false,
        },
        {
          link: "/web3-development-services/",
          label: "Web3 Development Services",
          disabled: false,
        },
        {
          link: "/token-development-services/",
          label: "Token Development",
          disabled: false,
        },
        {
          link: "/dapp-development-services/",
          label: "DApp Development",
          disabled: false,
        },
        {
          link: "/defi-platform-development/",
          label: "DeFi Development",
          disabled: false,
        },
        {
          link: "/nft-development-services/",
          label: "NFT Development",
          disabled: false,
          dropdown: true,
          subMenu: [
            {
              link: "/smart-contract-development/",
              label: "Smart Contract",
              disabled: false,
            },
            {
              link: "/blockchain-consulting-services/",
              label: "Blockchain Consultancy",
              disabled: false,
            },
          ],
        },
        {
          link: "/crypto-marketing-services/",
          label: "Crypto Marketing",
          disabled: false,
        },
        {
          link: "/dao-development-services/",
          label: "DAO Development",
          disabled: false,
        },
      ],
    },
    {
      mobileLabel: "View All",
      link: "/blockchain/",
      label: "Blockchain",
      disabled: false,
      dropdown: true,
      subMenuType: "list",
      subMenu: [
        {
          link: "/solana-blockchain-development/",
          label: "Solana Blockchain",
          disabled: false,
        },
        {
          link: "/substrate-development-services/",
          label: "Substrate Development",
          disabled: false,
        },
        {
          link: "/binance-smart-chain-development/",
          label: "Binance Development",
          disabled: false,
        },
        {
          link: "/polygon-blockchain-development/",
          label: "Polygon Development",
          disabled: false,
        },
        {
          link: "/polkadot-blockchain-development/",
          label: "Polkadot Development",
          disabled: false,
        },
        {
          link: "/ethereum-blockchain-development/",
          label: "Ethereum Development",
          disabled: false,
        },
        {
          link: "/cosmos-blockchain-development/",
          label: "Cosmos Development",
          disabled: false,
        },
        {
          link: "/algorand-blockchain-development/",
          label: "Algorand Development",
          disabled: false,
        },
        {
          link: "/hyperledger-blockchain-development/",
          label: "Hyperledger Development",
          disabled: false,
        },
        {
          link: "/cardano-blockchain-development/",
          label: "Cardano Development",
          disabled: false,
        },
      ],
    },
    {
      mobileLabel: "View All",
      link: "/technologies/",
      label: "Technologies",
      disabled: false,
      dropdown: true,
      subMenuType: "list",
      subMenu: [
        {
          link: "/hire-hyperledger-developers/",
          label: "Hire Hyperledger Developers",
          disabled: false,
        },
        {
          link: "/hire-rust-developers/",
          label: "Hire Rust Developers",
          disabled: false,
        },
        {
          link: "/hire-solidity-developers/",
          label: "Hire Solidity Developers",
          disabled: false,
        },
        {
          link: "/hire-golang-developers/",
          label: "Hire GoLang Developers",
          disabled: false,
        },
        {
          link: "/hire-nft-developer/",
          label: "Hire NFT Developers",
          disabled: false,
        },
        {
          link: "/hire-web3-developers/",
          label: "Hire Web3 Developers",
          disabled: false,
        },
        {
          link: "/hire-blockchain-developers/",
          label: "Hire Blockchain Developers",
          disabled: false,
        },
        {
          link: "/hire-javascript-developers/",
          label: "Hire Javascript Developers",
          disabled: false,
        },
        {
          link: "/hire-mern-stack-developer/",
          label: "Hire MERN Stack Developer",
          disabled: false,
        },
        {
          link: "/hire-mean-stack-developer/",
          label: "Hire MEAN Stack Developer",
          disabled: false,
        },
      ],
    },
  ];
  return (
    <div className={styles.wrap}>
      <Container className={`${styles.container}`}>
        <div className={styles.outer}>
          <div className={styles.cardblock}>
            <TabContainer
              activeKey={activeTab}
              id="left-tabs-example"
              onSelect={(tab) => setActiveTab(tab)}
            >
              <Row className={styles.row}>
                <Col lg={4} xl={3} className={`${styles.colLeft}`}>
                  <Nav variant="pills" className="flex-column">
                    {NavBarData?.map((item, id) => {
                      const {
                        label,
                        link,
                        disabled,
                        subMenu,
                        subMenuType,
                        mobileLabel,
                      } = item;
                      return (
                        <NavItem key={id}>
                          <NavLink
                            eventKey={id}
                            onMouseEnter={() => handleTabHover(id)}
                            aria-label={label}
                          >
                            <div className={styles.leftblock}>
                              <Row
                                className={`${styles.menuItem}`}
                                onMouseEnter={() => setShowIcon(id)}
                                onMouseLeave={() => setShowIcon(-1)}
                              >
                                <Col
                                  xs={11}
                                  md={11}
                                  className={`d-flex align-items-center px-0 ${styles.col}`}
                                >
                                  <h4 className={styles.subtitle}>
                                    {link ? (
                                      <Link
                                        to={link}
                                        className={`${styles.navlinkText}`}
                                        aria-label={label}
                                      >
                                        {label}
                                      </Link>
                                    ) : (
                                      label
                                    )}
                                  </h4>
                                </Col>
                                <Col
                                  xs={1}
                                  md={1}
                                  className={`align-items-center justify-content-center px-0 ${
                                    styles.col
                                  } ${showIcon === id ? "d-flex" : "d-none"}`}
                                >
                                  <FaChevronRight
                                    style={{ width: "8px" }}
                                    className={styles.dropdownIcon}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </NavLink>
                        </NavItem>
                      );
                    })}
                  </Nav>
                </Col>
                {/* <Col lg={2} xl={2} className={`${styles.colLine}`}>
                  <hr />
                </Col> */}
                <Col lg={8} xl={9}>
                  <TabContent>
                    {NavBarData?.map((item, id) => {
                      const { label, subMenu, subMenuType, link } = item;
                      return (
                        <TabPane eventKey={id} key={id}>
                          <div className={`${styles.textblock}`}>
                            {/* <p className={styles.subtitle}>{label}</p> */}
                            {subMenuType === "list" &&
                              subMenu &&
                              subMenu.map((subItem, subId) => (
                                <Col
                                  key={subId}
                                  xs={10}
                                  md={10}
                                  className={`d-flex  px-0 ${styles.dropdownTxt}`}
                                >
                                  <Link
                                    to={subItem.link}
                                    className={`${styles.subitemLink}`}
                                    aria-label={subItem.label}
                                  >
                                    <p className={`${styles.subItems}`}>
                                      {subItem.label}
                                    </p>
                                  </Link>
                                </Col>
                              ))}{" "}
                            <Link
                              to={`${link}`}
                              aria-label={`View All ${label}`}
                            >
                              <Button
                                className={`${styles.viewallBtn}`}
                                aria-label="View All"
                              >
                                View All
                              </Button>
                            </Link>
                          </div>
                        </TabPane>
                      );
                    })}
                  </TabContent>
                </Col>
              </Row>
            </TabContainer>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Services;
